import React from "react";

import { MCheckbox, MInput, MSelect, ValidatedForm } from "components/forms";
import { payloadBuilder, utilsService } from "libs";
import dayjs from "dayjs";
import { MnemoCallout } from "components/misc";

export class FormTitleITSStep1 extends ValidatedForm {
  constructor(props) {
    super(props);

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  emptyFields = {
    region: "",
    istitution: "",
    aa: "",
    dataConseguimento: "",
    votoTitolo: "",
    lode: "",
  };

  state = {
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    schools: [],
    regions: [],
  };

  ERROR_MESSAGES = {
    istitution: "Dato obbligatorio",
    aa: "Inserire l'anno accademico in formato AAAA/AAAA",
    dataConseguimento: "Dato obbligatorio",
    votoTitolo: "Dato obbligatorio e numerico",
  };

  validation = {
    istitution: (value) => value !== "",
    aa: (value) => this.validateAA(value),
    dataConseguimento: (value) => this.validateDataConseguimento(value),
    votoTitolo: (value) => this.validateVote(value),
  };

  loadRemote = () => {
    utilsService
      .getITSSchools()
      .then(({ data }) => {
        const schools = data.payload.result;

        const regions = [...new Set(schools.map((s) => s.region))]
          .sort()
          .map((reg) => ({ label: reg, value: reg }));

        this.allSchools = schools;

        const newState = {
          regions: [{ label: "Seleziona regione", value: "" }, ...regions],
        };

        const { defaultPayload } = this.props;

        if (defaultPayload && defaultPayload.istitution) {
          const defaultSchool = schools.find(
            (s) => s.name === defaultPayload.istitution
          );

          if (defaultSchool) {
            const defaultRegion = defaultSchool.region;

            const filteredSchools = schools
              .filter((s) => s.region === defaultRegion)
              .map((s) => ({ label: s.name, value: s.name }));

            newState.region = defaultRegion;

            newState.schools = [
              {
                label: `Seleziona istituto (${filteredSchools.length})`,
                value: "",
              },
              ...filteredSchools,
            ];

            newState.defaultValues = {
              ...this.state.defaultValues,
              ...defaultPayload,
              region: defaultRegion,
            };
          }
        }

        this.setState(newState);
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  };

  normalize = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.value !== undefined) return v.value;
    return v;
  };

  get FormTitleITSStep1Configurator() {
    return [
      [
        {
          field: "region",
          label: "Regione",
          component: MSelect,
          payload: { options: this.state.regions },
          className: "col-md-6",
          onChange: (field, value) => this.onChangeRegion(field, value),
        },
        {
          field: "istitution",
          label: "Istituto",
          component: MSelect,
          payload: { options: this.state.schools },
          className: "col-md-6",
        },
      ],
      [
        {
          field: "votoTitolo",
          label: "Voto",
          component: MInput,
          type: "text",
          className: "col-md-4",
        },
        {
          id: "lode",
          name: "lode",
          field: "lode",
          label: "Lode",
          component: MCheckbox,
          className: "col-md-4",
          infoText:
            "puoi selezionare la lode quando Voto e Base Voto sono uguali",
          onChange: () => this.onChangeLode(),
        },
      ],
      [
        {
          field: "aa",
          label: "Anno Scolastico conseguimento Titolo",
          component: MInput,
          infoText: "inserire formato AAAA/AAAA",
          className: "col-md-6 mt-4",
        },
        {
          field: "dataConseguimento",
          label: "Data conseguimento titolo",
          component: MInput,
          type: "date",
          className: "col-md-6 mt-4",
        },
      ],
    ];
  }

  //--- ---

  validateVote = (value) => {

    this.onChangeLode();
    if (value === "") {
      return false;
    }

    if (isNaN(value)) {
      return false;
    }

    if (value > 100 || value < 60) {
      return false;
    }

    return true;
  };

  validateAA = (value) => {
    this.setState({ dataConseguimento: { value: "" } });

    let formAA = /^(\d{4})\/(\d{4})$/.test(value);

    if (!formAA) {
      return false;
    } else {
      formAA = value.split("/");
      var dbAA = [];

      if (parseInt(formAA[1]) === parseInt(formAA[0]) + 1) {
        //--- ---
        if (
          this.props.item.aaStart !== null &&
          this.props.item.achievementDateEnd === null
        ) {
          //nell'anno aa
          dbAA = this.props.item.aaStart.split("/");
          if (parseInt(formAA[1]) < parseInt(dbAA[1])) {
            return false;
          }

          return true;
        }

        //--- ---
        if (
          this.props.item.aaStart !== null &&
          this.props.item.achievementDateEnd !== null
        ) {
          dbAA = this.props.item.aaStart.split("/");
          const DbdateY = dayjs(this.props.item.achievementDateEnd).format(
            "YYYY"
          );

          if (parseInt(formAA[1]) > parseInt(DbdateY)) {
            return false;
          }

          return true;
        }

        //--- ---
        if (this.props.item.aaEnd !== null) {
          //entro l'anno aa
          dbAA = this.props.item.aaEnd.split("/");
          if (parseInt(formAA[1]) > parseInt(dbAA[1])) {
            return false;
          }

          return true;
        }

        return true;
      } else {
        return false;
      }
    }
  }; //validateAA

  validateDataConseguimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }

    //--- ---
    const today = new Date();
    const formDate = new Date(value);

    if (formDate > today) {
      return false;
    }

    //--- ---
    if (Number.isNaN(formDate.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 90 || year > currentYear) {
      return false;
    }

    const aa = this.normalize(this.state.aa);

    if (aa) {
      const aaSplit = aa.split("/");
      if (parseInt(year) !== parseInt(aaSplit[1])) {
        return false;
      }
    }

    //--- ---
    if (this.props.item.achievementDateStart !== null) {
      const formDate = new Date(value);
      const Dbdate = new Date(
        dayjs(this.props.item.achievementDateStart).format("YYYY-MM-DD")
      );

      if (formDate < Dbdate) {
        return false;
      }

      return true;
    }

    //--- ---
    if (this.props.item.achievementDateEnd !== null) {
      const formDate = new Date(value);
      const Dbdate = new Date(
        dayjs(this.props.item.achievementDateEnd).format("YYYY-MM-DD")
      );

      if (formDate > Dbdate) {
        return false;
      }

      return true;
    }

    //--- ---
    if (this.props.item.aaEnd !== null) {
      //entro l'anno aa
      const dbAA = this.props.item.aaEnd.split("/");
      const formAA = value.split("/");
      if (parseInt(formAA[0]) > parseInt(dbAA[1])) {
        return false;
      }
    }

    if (
      this.props.item.achievementDateStart === null &&
      this.props.item.achievementDateEnd === null
    ) {
      return true;
    }
  };

  onChangeLode = () => {
    const votoTitolo = this.normalize(this.state.votoTitolo);
    const baseVote = 100;

    if (
      isNaN(votoTitolo) ||
      votoTitolo === "" ||
      parseInt(votoTitolo) !== parseInt(baseVote)
    ) {
      this.setState({ lode: { value: false, isValid: true } });
      return false;
    }

    return true;
  };

  onChangeRegion = (field, value) => {
    const filteredSchools = this.allSchools
      .filter((s) => s.region === value)
      .map((s) => ({ label: s.name, value: s.name }));

    this.setState({
      region: value,
      istitution: "",
      schools: [
        { label: `Seleziona istituto (${filteredSchools.length})`, value: "" },
        ...filteredSchools,
      ],
    });
  };

  componentDidMount() {
    this.loadRemote();

    const { defaultPayload } = this.props;

    if (defaultPayload) {
      this.setState({
        ...defaultPayload,
        defaultValues: {
          ...this.state.defaultValues,
          ...defaultPayload,
        },
      });
    }
  }

  getFormLabel = () => {
    return this.props.qualificationType;
  };

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = this.props.qualificationType;
    this.payload.description = this.props.qualificationType;
    this.payload.qualificationCode = "title11";
    this.payload.template = this.props.extCode;
    this.payload.extCode = this.props.extCode;
    this.payload.qteId = this.props.item.value;

    if (!this.payload.nation) {
      this.payload.nation = "Italia";
    }

    return this.payload;
  };

  //--- ---

  render() {
    const { defaultValues } = this.state;

    const { code } = this.renderFields(
      this.FormTitleITSStep1Configurator,
      defaultValues,
      true
    );

    return (
      <>
        {this.props.item.note && (
          <MnemoCallout>{this.props.item.note}</MnemoCallout>
        )}
        <form className="user mt-5">{code}</form>
      </>
    );
  }
}
